import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Support/Hero/Hero";
import Box from "../../components/Support/box/Box";
import UpButton from '../../components/UpButton';
import {products_last_part} from '../../Data/product_new' ;
import SubServPart from '../../components/SubServPart' ;
//============================================
import { Helmet } from "react-helmet";


const Support = ({scroll}) => {
  return (
    <div>
      <Helmet>
        <title>Millensys - Support</title>
      </Helmet>
      <UpButton scroll={scroll} />
      <div>
        <Header />
        <Hero />
        <Box/>
        <SubServPart products={products_last_part} title={'Value For Everyone'} overview={'Create and deliver a value for all stakeholders'}/>
        <Footer />
      </div>
    </div>
  );
};

export default Support;
